// Classes form a singly-linked progression via `next_class`. These helpers
// walk that chain to find classes a student could skip-promote to (ahead)
// or demote to (behind) relative to a given class, nearest first.

const buildById = (classes) => new Map((classes || []).map((c) => [c._id, c]));

export const getClassesAhead = (classes, currentClassId) => {
  const byId = buildById(classes);
  const result = [];
  const visited = new Set([currentClassId]);
  let cursor = byId.get(currentClassId);
  while (cursor?.next_class && byId.has(cursor.next_class) && !visited.has(cursor.next_class)) {
    const next = byId.get(cursor.next_class);
    result.push(next);
    visited.add(next._id);
    cursor = next;
  }
  return result;
};

export const getClassesBehind = (classes, currentClassId) => {
  const byId = buildById(classes);
  const pointingTo = new Map();
  (classes || []).forEach((c) => {
    if (c.next_class) pointingTo.set(c.next_class, c._id);
  });

  const result = [];
  const visited = new Set([currentClassId]);
  let cursorId = currentClassId;
  while (pointingTo.has(cursorId)) {
    const prevId = pointingTo.get(cursorId);
    if (visited.has(prevId)) break;
    const prev = byId.get(prevId);
    if (!prev) break;
    result.push(prev);
    visited.add(prevId);
    cursorId = prevId;
  }
  return result;
};
